import { render, staticRenderFns } from "./MarkDetailPage.vue?vue&type=template&id=f85629e0&scoped=true&"
import script from "./MarkDetailPage.vue?vue&type=script&lang=js&"
export * from "./MarkDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./MarkDetailPage.vue?vue&type=style&index=0&id=f85629e0&scoped=true&lang=css&"
import style1 from "./MarkDetailPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85629e0",
  null
  
)

export default component.exports